import { render, staticRenderFns } from "./EditPhoto.vue?vue&type=template&id=5d5d0acb&scoped=true&"
import script from "./EditPhoto.vue?vue&type=script&lang=js&"
export * from "./EditPhoto.vue?vue&type=script&lang=js&"
import style0 from "./EditPhoto.vue?vue&type=style&index=0&id=5d5d0acb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d0acb",
  null
  
)

export default component.exports